<template>
  <div class="exerciseWithBottomControls">
    <NavigationBar :color="color" :theme="theme"></NavigationBar>
    <slot></slot>
  </div>
</template>

<script>

  import NavigationBar from "@/components/bars/NavigationBar";
  export default {
    name: 'ExerciseWithBottomControls',
    components: {NavigationBar},
    props: ['color', 'theme'],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

<style lang="scss">
  .exerciseWithBottomControls {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    padding: 0 !important;
    margin: 0 !important;
    overflow: hidden;
  }
</style>
